import t, { Component as i } from "react";

function n() {
  return (n = Object.assign || function (t) {
    for (var i = 1; i < arguments.length; i++) {
      var n = arguments[i];

      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }

    return t;
  }).apply(this, arguments);
}

function r(t, i) {
  if (null == t) return {};
  var n,
      r,
      s = {},
      h = Object.keys(t);

  for (r = 0; r < h.length; r++) i.indexOf(n = h[r]) >= 0 || (s[n] = t[n]);

  return s;
}

var s = function (i) {
  var s, h;

  function e(n) {
    var r;
    return (r = i.call(this, n) || this).t = function () {
      return r.i.current.offsetWidth;
    }, r.h = function () {
      return r.i.current.offsetHeight;
    }, r.i = t.createRef(), r.state = {
      path: ""
    }, r.u = 0, r.o = 0, r.l = 0, r.v = r.v.bind(function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(r)), r;
  }

  h = i, (s = e).prototype = Object.create(h.prototype), s.prototype.constructor = s, s.__proto__ = h;
  var u = e.prototype;
  return u.p = function () {
    for (var t = [], i = 0; i <= Math.max(this.props.points, 1); i++) {
      var n = i / this.props.points * this.t(),
          r = (this.l + (i + i % this.props.points)) * this.props.speed * 100,
          s = Math.sin(r / 100) * this.props.amplitude,
          h = Math.sin(r / 100) * s + this.props.height;
      t.push({
        x: n,
        y: h
      });
    }

    return t;
  }, u.m = function (t) {
    var i = "M " + t[0].x + " " + t[0].y,
        n = {
      x: (t[1].x - t[0].x) / 2,
      y: t[1].y - t[0].y + t[0].y + (t[1].y - t[0].y)
    },
        r = function (t, i) {
      return " C " + t.x + " " + t.y + " " + t.x + " " + t.y + " " + i.x + " " + i.y;
    };

    i += r(n, t[1]);

    for (var s = n, h = 1; h < t.length - 1; h++) i += r(s = {
      x: t[h].x - s.x + t[h].x,
      y: t[h].y - s.y + t[h].y
    }, t[h + 1]);

    return (i += " L " + this.t() + " " + this.h()) + " L 0 " + this.h() + " Z";
  }, u.g = function () {
    this.setState({
      path: this.m(this.p())
    });
  }, u.M = function () {
    if (!this.props.paused) {
      var t = new Date();
      this.o += t - this.u, this.u = t;
    }

    this.l = this.o * Math.PI / 1e3, this.g();
  }, u.v = function () {
    this.M(), this.j && this.O();
  }, u.O = function () {
    this.j = window.requestAnimationFrame(this.v), this.u = new Date();
  }, u.componentDidMount = function () {
    this.j || this.O();
  }, u.componentWillUnmount = function () {
    window.cancelAnimationFrame(this.j), this.j = 0;
  }, u.render = function () {
    var i = this.props,
        s = i.style,
        h = i.className,
        e = i.fill,
        u = i.children,
        a = i.id,
        f = r(i, ["style", "className", "fill", "paused", "children", "id", "d", "ref"]);
    return t.createElement("div", {
      style: n({
        width: "100%",
        display: "inline-block"
      }, s),
      className: h,
      id: a,
      ref: this.i
    }, t.createElement("svg", {
      width: "100%",
      height: "100%",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, u, t.createElement("path", n({
      d: this.state.path,
      fill: e
    }, f))));
  }, e;
}(i),
    h = {
  height: 20,
  amplitude: 20,
  speed: .15,
  points: 3
},
    e = function (i) {
  var e = i.options,
      u = r(i, ["options"]);
  return t.createElement(s, n({}, h, e, u));
};

e.defaultProps = {
  paused: !1,
  fill: "#fff"
};
export default e;